import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=035ece90&scoped=true&"
import script from "./Error404.vue?vue&type=script&lang=ts&"
export * from "./Error404.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035ece90",
  null
  
)

export default component.exports